import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://app.grupomyshop.com.br',
  withCredentials: true, // ESSENCIAL pro cookie rt
});
